module.exports = __webpack_public_path__ + "img/147.5ff6ff3e.jpg";